export default "__VITE_ASSET__BSkWu5W6__"